import { createSelector } from 'reselect'

const id = (state, id) => id
const $$byId = ({ members }) => members.$$byId
const member = (id, $$byId) => $$byId.get(String(id))
const getMember = createSelector(id, $$byId, member)

export default getMember
